/* eslint-disable import/prefer-default-export */
import React from 'react'
import type {
  MakeRequestOptions,
  RequestOptions
} from '@src/endpoints/make.request'
import {
  getFeatureFlagAsync,
  GetFeatureFlagAsyncResp,
  RegistredFeatureflag
} from '@src/endpoints/feature.flag'
import type { GetFeatureFlagReq } from '@src/endpoints/services/tenantMgr.service'

export const useFeatureFlagFetch = (
  flag: RegistredFeatureflag,
  deps: ReadonlyArray<any> = [],
  options?: RequestOptions,
  makeRequestOptions?: Partial<MakeRequestOptions<GetFeatureFlagReq>>
) => {
  const [response, setResponse] = React.useState<GetFeatureFlagAsyncResp>(null)
  const [error, setError] = React.useState(null)
  const [pending, setPending] = React.useState(false)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setPending(true)
        const res = await getFeatureFlagAsync(flag, options, makeRequestOptions)
        setResponse(res)
        setError(res?.error || null)
        setPending(false)
      } catch (error) {
        setResponse(null)
        setError(error)
        setPending(false)
      }
    }
    if (flag) {
      fetchData()
    }
  }, deps)

  return { response, error, pending }
}
